import React from 'react'
import styled from '@emotion/styled'
import { colors, spacing } from '@mobi/component-library/Theme/Common'
import { addToast } from '@mobi/component-library/Feedback/Toast'
import { Icon } from '@mobi/component-library/Common/V2'
import type {
  TicketShare,
  BetSlipShare,
  QuickbetShare,
  KambiSportsShare,
} from '@core/Areas/ShareBet/types'
import { BetLoopShareButton } from './Components/BetLoopShareButton'
import { ShareOptionButton } from './Components/Common/ShareOptionButton'

export const ShareOptions: React.FC<{
  handleShareWithExternalClick(): void
  data: TicketShare | BetSlipShare | QuickbetShare | KambiSportsShare
  dismissTray(): void
}> = ({ handleShareWithExternalClick, data, dismissTray }) => {
  const isKambiShare = data.contextType === 'kambi'
  const shouldDisableExternalShare = isKambiShare && data.share.coupon.bets.length > 1

  const handleBlockedExternalShareClick = () => {
    addToast({
      id: 'share-external-blocked',
      isDismissable: true,
      title: "Sharing multiple bets isn't available right now",
      icon: 'warning',
      theme: 'dark',
    })
  }

  return (
    <WrapperStyled>
      {shouldDisableExternalShare ? (
        <ShareOptionButton isBlocked>
          <button type='button' onClick={handleBlockedExternalShareClick}>
            <ExternalShareButtonContent isBlocked />
          </button>
        </ShareOptionButton>
      ) : (
        <ShareOptionButton>
          <button onClick={handleShareWithExternalClick} type='button'>
            <ExternalShareButtonContent />
          </button>
        </ShareOptionButton>
      )}

      <BetLoopShareButton data={data} dismissTray={dismissTray} />
    </WrapperStyled>
  )
}

// ===============
// Local Component
// ===============

const ExternalShareButtonContent: React.FC<{ isBlocked?: boolean }> = ({ isBlocked }) => (
  <>
    <span>
      <Icon name='LineShare02' color={isBlocked ? colors.neutral[500] : colors.studio[600]} />
    </span>
    Share via...
  </>
)

// ======
// Styles
// ======

const WrapperStyled = styled.div({
  display: 'grid',
  gridAutoFlow: 'column',
  gridAutoColumns: 'minmax(0, 1fr)',
  gap: spacing.smx1,
})
